import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';
import { menu } from './menu';
import Select from './components/Select.vue';

export const SkladNovychVozu = {
	name: NAME,
	apiProvider,
	router,
	menu,
	components: {
		Select,
	},
};
